'use client';

import { useMemo, type FC } from 'react';
import { type ExpandedButtonProps } from './expanded-button.types';
import { Icon, Text, cn } from '@kidslabs/mario-nextjs-react-ui-core';
import styles from './expanded-button.module.css';

export const ExpandedButton: FC<ExpandedButtonProps> = ({ toggleExpanded, isExpanded, text, className }) => {
    const iconName = useMemo(() => (isExpanded ? 'chevron-up' : 'chevron-down'), [isExpanded]);

    return (
        <button
            type="button"
            data-testid="button-expanded"
            onClick={toggleExpanded}
            className={cn(styles.expandedButton, className)}
            aria-expanded={isExpanded}
        >
            <Text className={styles.text}>{text}</Text>
            <Icon name={iconName} size={24} className={styles.icon} />
        </button>
    );
};
